import PropTypes from 'prop-types'
import classNames from 'classnames'

import ShareOnFacebook from './facebook'
import ShareOnTwitter from './twitter'
import ShareOnLinkedin from './linkedin'

const Share = ({ size = 32, url, extended, horizontal, light, ...attrs }) => {
  attrs.className = classNames(
    attrs.className,
    [
      'bg-white',
      'flex',
      'flex-row'
    ]
  )
  attrs.style = {
    ...(attrs.style || {})
  }

  return <div
    {...attrs}
    onClick={(e) => { e.stopPropagation() }} >
    <ShareOnFacebook outline url={url} className={'mr-4'} />
    <ShareOnTwitter outline url={url} className={'mr-4'} />
    <ShareOnLinkedin outline url={url} className={'mr-4'} />
  </div>
}

Share.propTypes = {
  size: PropTypes.number,
  url: PropTypes.string,
  appId: PropTypes.string,
  extended: PropTypes.bool,
  horizontal: PropTypes.bool,
  light: PropTypes.bool,
  icon: PropTypes.oneOfType([PropTypes.node, PropTypes.element, PropTypes.func])
}

export default Share
